import styled, { css } from 'styled-components';
import CheckImg from 'products/nomad_insurance/assets/img/icons/checkmark.svg';
import XImg from 'products/nomad_insurance/assets/img/icons/x.svg';
import { sizes } from 'style';
import { th } from 'style/theme';

export const ProgressContainer = styled.div`
  width: 100%;
  padding-top: 24px;

  @media ${sizes.desktop} {
    padding-top: 0px;
  }
`;

export const ProgressIndicatorBg = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: ${th('colors.black')}33;
`;

export const ProgressIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ percentage }) => `${percentage}%`};
  height: 6px;
  border-radius: 3px;
  background-color: ${th('colors.black')};
`;

export const Statuses = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 14px;
  color: ${th('colors.pickledBluewood2')};

  @media ${sizes.desktop} {
    font-size: 16px;
  }
`;

export const StatusText = styled.span`
  position: relative;
  font-weight: ${({ $isBold }) => ($isBold ? 600 : 400)};
  color: ${({ $isDeclined, $isBold }) => {
    return (() => {
      if ($isDeclined) return th('colors.red');
      if ($isBold) return th('colors.pickledBluewood');
      return 'inherit';
    })();
  }};
  flex-basis: 75px;
  flex-grow: 1;

  :nth-child(2) {
    text-align: center;
  }
  :nth-child(3) {
    text-align: right;
  }

  @media ${sizes.tabletLandscape} {
    flex-basis: 100px;
  }

  ${({ $isPast }) =>
    $isPast &&
    css`
      ::before {
        content: ' ';
        position: absolute;
        top: -28px;
        left: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: ${th('colors.white')};
        box-shadow: ${th('shadows.small')};
        background-image: ${({ $isDeclined }) =>
          $isDeclined ? `url(${XImg})` : `url(${CheckImg})`};
        background-size: 100%;
        background-position: center center;
        background-repeat: no-repeat;
      }

      :nth-child(2)::before {
        left: 50%;
        transform: translateX(-50%);
      }
      :last-child::before {
        right: 0;
        left: initial;
      }
    `}
`;
export const Dates = styled(Statuses)`
  margin-top: 6px;
  color: ${th('colors.black')};
`;
